import z from "zod";
import { auditableSchema, entitySchema, PaginatedResponseBuilder, paginationParamsSchema } from "../shared.types";

////////
// Types used specifically for Job Titles APIs
////////

export const jobTitlesSearchSchema = z.object({
    ...paginationParamsSchema.shape,
    subscriptionId: z.number().int().optional(),
    isActive: z.boolean().optional().nullable(),
    name: z.string().nullable().optional(),
});

export const jobTitleSchema = z.object({
    ...entitySchema.shape,
    ...auditableSchema.shape,
    subscriptionId: z.number().int(),
    name: z.string().min(1, "Name cannot be empty"),
    isActive: z.boolean(),
});

// Create a specific schema for paginated job titles
export const paginatedJobTitleResponseSchema = PaginatedResponseBuilder(jobTitleSchema);

// Infer the types from the specific schemas
export type JobTitle = z.infer<typeof jobTitleSchema>;
export type JobTitlesSearch = z.infer<typeof jobTitlesSearchSchema>;
export type PaginatedJobTitleResponse = z.infer<typeof paginatedJobTitleResponseSchema>;
